import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/system";
import { color } from "../../mui-theme/palette";

export interface ActionButton {
  text: string;
  onClick?: () => void;
  disabled?: boolean;
  variant?: "contained" | "outlined" | "text";
  colorType?: "primary" | "secondary" | "danger";
}

interface ActionButtonGroupProps {
  buttons: ActionButton[];
  orientation?: "horizontal" | "vertical";
}

const StyledButton = styled(Button)<{ colorType?: string }>(({ colorType, disabled }) => {
  if (colorType === "primary") {
    return {
      backgroundColor: color.majorRed,
      color: color.white,
      borderRadius: 12,
      flex: 1,
      fontSize: 16,
      fontWeight: 600,
      lineHeight: "24px",
      padding: 12,
      textTransform: "none",
      "&:hover": {
        backgroundColor: color.majorRed,
      },
      "&:disabled": {
        backgroundColor: color.greyCc,
        color: color.white,
      },
    };
  }
  if (colorType === "secondary") {
    return {
      backgroundColor: color.white,
      color: color.grey33,
      border: `2px solid ${color.greyCc}`,
      borderRadius: 12,
      flex: 1,
      fontSize: 16,
      fontWeight: 600,
      lineHeight: "24px",
      padding: 12,
      textTransform: "none",
      "&:hover": {
        backgroundColor: color.white,
      },
      "&:disabled": {
        backgroundColor: color.white,
        color: color.greyCc,
        border: `2px solid ${color.greyCc}`,
      },
    };
  }
  if (colorType === "danger") {
    return {
      backgroundColor: color.majorRed,
      color: color.white,
      borderRadius: 12,
      flex: 1,
      fontSize: 16,
      fontWeight: 600,
      lineHeight: "24px",
      padding: 12,
      textTransform: "none",
      "&:hover": {
        backgroundColor: color.majorRed,
      },
      "&:disabled": {
        backgroundColor: color.greyCc,
        color: color.white,
      },
    };
  }
  return {
    backgroundColor: color.white,
    color: color.grey33,
    border: `2px solid ${color.greyCc}`,
    borderRadius: 12,
    flex: 1,
    fontSize: 16,
    fontWeight: 600,
    lineHeight: "24px",
    padding: 12,
    textTransform: "none",
    "&:hover": {
      backgroundColor: color.white,
    },
    "&:disabled": {
      backgroundColor: color.white,
      color: color.greyCc,
      border: `2px solid ${color.greyCc}`,
    },
  };
});

export const ActionButtonGroup: React.FC<ActionButtonGroupProps> = ({
  buttons,
  orientation = "vertical",
}) => (
  <div className={`flex flex-1 ${orientation === "horizontal" ? "flex-row" : "flex-col"}`}>
    {buttons.map((btn, idx) => (
      <React.Fragment key={btn.text + idx}>
        <StyledButton
          variant={btn.variant ?? (btn.colorType === "secondary" ? "outlined" : "contained")}
          colorType={btn.colorType}
          disabled={btn.disabled}
          onClick={btn.onClick}
        >
          {btn.text}
        </StyledButton>
        {idx < buttons.length - 1 && <div className="p-2" />}
      </React.Fragment>
    ))}
  </div>
);
